import { Component } from "react"
import PropTypes from "prop-types"
import isEmpty from "lodash/isEmpty"
import debounce from "lodash/debounce"

import SearchInput from "app/components/ifttt_next/shared/search_input"

class SearchBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      textAddress: props.textAddress,
      focused: false,
    }

    this.onChange = this.onChange.bind(this)
    this.onClear = this.onClear.bind(this)
    this.submitEnteredAddress = this.submitEnteredAddress.bind(this)
    this.setEnteredAddress = this.setEnteredAddress.bind(this)
    this.debouncedSetAddress = debounce(this.setEnteredAddress, 1000)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.focused) {
      this.setState({ textAddress: nextProps.textAddress })
    }
  }

  onChange = e => {
    const text = e.target.value

    this.setState({ textAddress: text }, () => this.debouncedSetAddress(text))
  }

  onClear = () => {
    this.setState({ textAddress: "" }, () => {
      this.inputRef?.focus()
      this.setEnteredAddress("")
    })
  }

  setEnteredAddress(text) {
    this.props.onAddressChanged(text, false)

    // On touch devices the keyboard covers the map the geocoder just moved.
    const touchDevice = !!("ontouchstart" in document.documentElement)
    touchDevice && this.inputRef?.textinputRef?.blur()
  }

  submitEnteredAddress() {
    this.setEnteredAddress(this.state.textAddress)
  }

  render() {
    return (
      <SearchInput
        ref={r => (this.inputRef = r)}
        value={this.state.textAddress}
        onChange={this.onChange}
        onClick={() => this.setState({ focused: true })}
        onBlur={e => {
          e.preventDefault()
          this.setState({ focused: false })
          this.submitEnteredAddress()
        }}
        onKeyDown={e => e.keyCode === 13 && this.submitEnteredAddress()}
        showCloseIcon={!isEmpty(this.state.textAddress)}
        onXClick={this.onClear}
        placeholder="Enter an address"
      />
    )
  }
}

SearchBar.propTypes = {
  textAddress: PropTypes.string,
  onAddressChanged: PropTypes.func,
}

export default SearchBar
